module.exports = __webpack_public_path__ + "static/media/ic-train@3x.19b7df49.png";